export default {
  value: {
    type: Object,
    default: () => {
      return {}
    },
  },
  tagText: {
    type: String,
    default: '',
  },
  modalFormBodyBgc: {
    type: Boolean,
    default: false,
  },
  modalFormWidth: {
    type: [String, Number],
    default: '605',
  },
  operateCellShow: {
    type: Boolean,
    default: false,
  },
  tableRowMenuItem: {
    type: Array,
    default: () => {
      return [
        {
          icon: 'ivu-icon-icon-pg-edit',
          name: '编辑地址库信息',
          type: 'edit',
          style: '',
        },
        {
          icon: 'ivu-icon-icon-pg-delete',
          name: '删除',
          type: 'remove',
          style: 'error',
        },
      ]
    },
  },
  tableColumnDefUrl: {
    type: String,
    default: '',
  },
  sideModalWidth: {
    type: [String, Number],
    default: '800',
  },
  urlQueryAddress: {
    type: String,
    default: '',
  },
  // 新增地址 (存入地址表)
  urlSaveAddress: {
    type: String,
    default: '',
  },
  // 详情 保存地址(直接存入form)
  urlSaveAddressForDetail: {
    type: String,
    default: '',
  },
  urlRemoveAddress: {
    type: String,
    default: '',
  },
  requestParam: {
    type: [String, Object],
    default: null,
  },
  urlModalFormItemsDef: {
    type: String,
    default: '',
  },
  urlGetOfEdit: {
    type: String,
    default: '',
  },
  urlDistrictlForModifySideModal: {
    type: String,
    default: '',
  },
  editDisabled: {
    type: Boolean,
    default: false,
  },
  requestMethod: {
    type: String,
    default: 'post',
  },
  searchKey: {
    type: String,
    default: 'keyword',
  },
  multiple: {
    type: Boolean,
    default: false,
  },
  index: {
    type: Boolean,
    default: false,
  },
  transfer: {
    type: Boolean,
    default: true,
  },
  placeholder: {
    type: String,
    default: '省市区/联系人/手机号/详细地址/邮编',
  },
  title: {
    type: String,
    default: '选择',
  },
  // modalFromTitle: {
  //     type: String,
  //     default: '提示'
  // },
  readonly: {
    type: Boolean,
    default: false,
  },
  urlRemoveForRow: {
    type: String,
    default: '',
  },
  addressType: {
    type: String,
    default: '收货方',
  },
  showIconClose: {
    type: Boolean,
    default: true,
  },
  //提示信息
  promptContent: {
    type: String,
    default: '请先选合作单位',
  },
}
